// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 499 ? "admin-pages" : chunkId) + "." + {"499":"0a906705","834":"1975a99d"}[chunkId] + ".chunk.css";
};